'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# ScalesBadgeSVG
An SVG badge shaped like the state of Ohio containing a scales icon.
 */
var ScalesBadgeSVG = function ScalesBadgeSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === undefined ? _config.colors.darkRed : _ref$badgeColor,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === undefined ? _config.colors.white : _ref$iconColor;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 473 492',
      'aria-label': 'Scales Badge',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Scales Badge'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'A badge shaped like the state of Ohio containing a scales icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          fillRule: 'nonzero'
        },
        _react2.default.createElement(
          'g',
          {
            fill: badgeColor
          },
          _react2.default.createElement('path', {
            d: 'M464.276409,0.977591353 C473.084042,-0.570261623 472.268521,8.06512866 472.268521,13.1974833 C472.431625,79.1034336 472.431625,145.09085 472.431625,210.9968 C472.431625,274.29584 471.86076,335.232368 471.86076,398.612874 C465.581244,400.975387 459.464832,403.419365 453.185317,405.944809 C391.531889,429.407002 330.041565,452.869194 268.551241,476.575785 C258.764983,480.404684 252.648571,482.848662 240.415748,487.818085 C232.91295,491.076723 231.281907,489.610336 224.105318,487.003426 C213.829746,482.441333 205.26677,479.508559 194.338782,475.272329 C129.749476,450.180818 65.2417227,425.578102 0.489312921,400.649523 C0.489312921,272.747987 0.489312921,145.009384 0.489312921,17.0263827 C54.721495,17.1893146 108.953677,17.7595762 162.941203,17.1893146 C177.049725,17.0263827 186.917536,20.6108844 195.562064,32.5049125 C215.134581,59.7960044 240.905061,68.9201904 273.933683,57.7593558 C298.970194,49.3683633 325.066884,44.8062703 350.266499,37.2299374 C388.677563,25.9061709 426.354658,13.1974833 464.276409,0.977591353 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(97.603175, 142.500000)',
            fill: iconColor
          },
          _react2.default.createElement('path', {
            d: 'M50.2318627,47.1948925 C50.7794846,48.1397849 51.177755,48.8857527 51.6755931,49.6317204 C61.83149,65.7446237 71.9873869,81.8077957 82.1432838,97.9206989 C84.5329066,101.700269 83.9355009,105.081989 80.6995534,106.922043 C77.9116601,108.46371 74.7752802,107.419355 72.7341441,104.186828 C64.4700319,91.1075269 56.2059197,78.0282258 47.9418075,64.8991935 C46.9461313,63.3077957 45.9006713,61.7163978 44.7556437,59.8763441 C42.7642914,62.9596774 40.9222905,65.8938172 39.0802896,68.7782258 C31.5629345,80.6639785 24.0953633,92.5994624 16.5282244,104.485215 C14.0888178,108.314516 9.70784264,108.662634 6.96973317,105.380376 C5.37665131,103.391129 5.37665131,101.053763 7.1190846,98.2688172 C13.8398987,87.6263441 20.5607129,76.983871 27.2317432,66.3413978 C31.2144479,60.0255376 35.1473687,53.7594086 39.2794248,47.2446237 C38.6322353,47.0456989 38.1343972,46.8467742 37.6365591,46.6975806 C32.6581783,45.6532258 29.9698526,42.0725806 30.3681231,37.0497312 C30.7166098,32.7728495 34.2512602,29.5403226 39.0802896,29.4905914 C50.132295,29.391129 61.1345167,29.4408602 72.1865222,29.4408602 C81.8943648,29.4408602 91.6022074,29.391129 101.31005,29.4905914 C102.753781,29.4905914 103.699673,29.1424731 104.645565,27.9489247 C107.931297,23.8212366 112.013569,20.5887097 117.141301,18.8481183 C118.385896,18.4005376 118.883734,17.8037634 119.132653,16.4112903 C120.427032,8.55376344 127.695469,-0.497311828 140.290772,0.149193548 C148.803803,0.596774194 156.719429,7.40994624 158.461862,16.5107527 C158.611214,17.405914 159.60689,18.4502688 160.502998,18.7983871 C165.431595,20.688172 169.513868,23.7715054 172.749815,27.8494624 C173.745491,29.0927419 174.790951,29.4905914 176.284465,29.4905914 C196.297556,29.4408602 216.260864,29.4408602 236.273955,29.4905914 C237.817253,29.4905914 239.460118,29.4905914 240.953633,29.8884409 C244.886553,30.9327957 247.276176,34.5134409 247.126825,38.6908602 C246.977473,42.5698925 244.139796,45.8024194 240.157092,46.5981183 C239.60947,46.6975806 239.061848,46.8965054 238.215523,47.0954301 C238.763145,48.0403226 239.260983,48.8857527 239.758821,49.6814516 C249.914718,65.7943548 260.070615,81.9072581 270.226512,97.9704301 C271.720026,100.307796 272.466783,102.645161 270.72435,105.13172 C268.185376,108.712366 263.455914,108.413978 261.016507,104.584677 C253.99699,93.5443548 247.077041,82.4543011 240.057524,71.4139785 C237.667901,67.6344086 235.278278,63.8548387 232.789088,59.8763441 C229.354005,65.297043 226.01849,70.5188172 222.732759,75.7903226 C216.659134,85.3884409 210.635293,94.9865591 204.611452,104.584677 C203.018371,107.071237 200.728315,108.165323 198.338693,107.518817 C195.849502,106.872312 194.057285,105.231183 194.007501,102.694892 C194.007501,101.004032 194.754258,99.1639785 195.700151,97.672043 C205.75648,81.608871 215.862593,65.5954301 225.968706,49.5322581 C226.416761,48.8360215 226.815031,48.1397849 227.362653,47.1948925 C201.524856,47.1948925 175.985763,47.1948925 150.19775,47.1948925 C150.19775,103.092742 150.19775,159.040323 150.19775,215.336022 C153.682616,215.336022 157.067915,215.28629 160.403431,215.336022 C164.037649,215.385753 167.72165,215.385753 171.355868,215.634409 C180.565873,216.330645 188.979337,226.127688 188.083228,235.079301 C155.225915,235.079301 122.318817,235.079301 89.1628008,235.079301 C89.2125846,228.71371 91.8013427,223.69086 96.5805883,219.762097 C100.662861,216.380376 105.541674,215.28629 110.71919,215.336022 C116.195409,215.385753 121.671628,215.336022 127.297198,215.336022 C127.297198,159.239247 127.297198,103.341398 127.297198,47.1948925 C101.758104,47.1948925 76.119443,47.1948925 50.2318627,47.1948925 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M232.888656,113.685484 C246.230716,113.685484 259.572777,113.685484 272.914838,113.685484 C276.598839,113.685484 277.494948,114.481183 277.39538,118.211022 C276.748191,137.954301 262.958076,155.111559 243.641958,159.885753 C217.903729,166.301075 192.713122,149.392473 188.63085,122.985215 C188.332147,121.194892 188.23258,119.354839 188.182796,117.564516 C188.133012,114.680108 189.078904,113.685484 192.016149,113.685484 C202.6201,113.685484 213.224051,113.685484 223.828003,113.685484 C226.914599,113.685484 229.901627,113.685484 232.888656,113.685484 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M44.7058599,113.685484 C58.1474882,113.685484 71.5891165,113.685484 84.9809609,113.685484 C88.4658275,113.685484 89.2623684,114.530914 89.2623684,117.912634 C89.0632332,140.241935 70.5934403,159.388441 48.2902941,161.079301 C25.1408232,162.819892 4.82902941,146.806452 0.746757126,124.526882 C0.348486659,122.33871 0.149351425,120.100806 0.0497838084,117.862903 C-0.0497838084,114.729839 0.995676168,113.685484 4.1320561,113.685484 C17.7230358,113.685484 31.2144479,113.685484 44.7058599,113.685484 Z'
          })
        )
      )
    )
  );
};

ScalesBadgeSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  badgeColor: _propTypes2.default.string,
  iconColor: _propTypes2.default.string
};

ScalesBadgeSVG.displayName = 'ScalesBadgeSVG';

exports.default = ScalesBadgeSVG;
ScalesBadgeSVG.__docgenInfo = {
  'description': '# ScalesBadgeSVG\r\nAn SVG badge shaped like the state of Ohio containing a scales icon.',
  'methods': [],
  'displayName': 'ScalesBadgeSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'badgeColor': {
      'defaultValue': {
        'value': 'colors.darkRed',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'iconColor': {
      'defaultValue': {
        'value': 'colors.white',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    }
  }
};